/* eslint-disable max-lines-per-function */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useMemo, useEffect } from "react";
import { Box, TextField, Typography, FormControl, InputLabel, Chip, Select, MenuItem, FormLabel, FormHelperText, Link } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import InputAdornment from "@mui/material/InputAdornment";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { ThemeProvider } from "@mui/material/styles";
import en from '../../nls/en.json';
import { theme, ChipWrapper } from "../Styles/BasicInfo";
import { useSelector } from "react-redux";
import { isEmpty, chipDesignValues } from "../../utils/constants";
import { validateFormBasicInfoOnChange } from "../../utils/validation";
import { getHighSchooList } from "../../store/studentSlice";
import { getUniversityList } from "../../store/userSlice";
import { useDispatch } from "react-redux";
import Checkbox from '@mui/material/Checkbox';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const BasicInfo = ({ getBasicInfo, isConsignmentChecked, setconsignment, isSMSChecked, setMentorSMS, isPolicyAndCondChecked, setPolicyConditions }) => {

  const { userInfo, savedAnswer, schoolList, formErrorsBasicInfo, highSchoolList } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
  const { universityList } = useSelector(({ userSliceHome }) => userSliceHome);
  const { BASIC_INFORMATION } = savedAnswer;

  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState(formErrorsBasicInfo || {});
  const [selectedMajors, setMajors] = useState([]);
  const [selectedMinors, setMinors] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchQueryUniversity, setSearchQueryUniversity] = useState('');

  useEffect(() => {
    dispatch(getUniversityList())
  }, [])

  const [formData, setFormData] = useState({
    name: '',
    lastName: '',
    gender: '',
    mobile: '',
    hometown: '',
    highschool_id: '',
    school_id: '',
    grad_year: '',
    major: '',
    minor: '',
    google_meet_link: 'https://',
    bio: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const errors = validateFormBasicInfoOnChange(
      { ...formData, [name]: value },
      "",
      name,
      formErrors
    );
    setFormErrors(errors);
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleDeleteChip = (type, id) => {
    if (type === "minor") setMinors((selectedMinors) => selectedMinors?.filter((chip) => chip?.id !== id));
    if (type === "major") setMajors((selectedMajors) => selectedMajors?.filter((chip) => chip?.id !== id));
  }

  const isDuplicate = (arr, val) => !!arr.find((ele) => ele?.name?.toLowerCase() === val?.toLowerCase());

  const handleAddChip = (type) => {

    setFormData((prevData) => ({ ...prevData, [type]: "" }));
    if (type === "minor" && !isDuplicate(selectedMinors, formData?.minor) && !isEmpty(formData?.minor?.trim()) && selectedMinors?.length < 2) {
      setMinors((prev) => [...prev, { id: prev?.length + 1, name: formData?.minor }]);
    }
    if (type === "major" && !isDuplicate(selectedMajors, formData?.major) && !isEmpty(formData?.major?.trim()) && selectedMajors?.length < 2) {
      setMajors((prev) => [...prev, { id: prev?.length + 1, name: formData?.major }]);
    }
  }

  const handleHighSchoolInputChange = (event, newInputValue) => {
    setSearchQuery(newInputValue);
    setTimeout(() => {
      dispatch(getHighSchooList(1, highSchoolList?.result, newInputValue));
    }, 200);
  };

  const handleSchoolInputChange = (event, newInputValue) => {
    setSearchQueryUniversity(newInputValue);
    setTimeout(() => {
      dispatch(getUniversityList(1, [], newInputValue));
    }, 200);
  };

  const loadMoreResultsUniversity = () => {
    if (universityList?.pagination?.isNextPage) {
      dispatch(getUniversityList(universityList?.pagination?.nextPage, universityList?.result, searchQueryUniversity))
    }
  }
  const loadMoreResults = () => {
    if (highSchoolList?.pagination?.isNextPage) {
      dispatch(getHighSchooList(highSchoolList?.pagination?.nextPage, highSchoolList?.result))
    }
  }

  useMemo(() => {
    if (!isEmpty(BASIC_INFORMATION)) {
      setFormData((prevData) => ({
        ...prevData,
        name: BASIC_INFORMATION?.name?.split(" ")[0],
        lastName: BASIC_INFORMATION?.name?.split(" ")[1],
        gender: BASIC_INFORMATION?.gender,
        mobile: BASIC_INFORMATION?.mobile,
        hometown: BASIC_INFORMATION?.hometown,
        school_id: BASIC_INFORMATION?.school_id,
        highschool_id: BASIC_INFORMATION?.highschool_id,
        other_school: BASIC_INFORMATION?.Hometown,
        grad_year: BASIC_INFORMATION?.graduation_year,
        google_meet_link: BASIC_INFORMATION?.google_meet_link || 'https://',
        bio: BASIC_INFORMATION?.bio
      }));
    }
  }, [BASIC_INFORMATION]);

  useEffect(() => {
    setMajors(chipDesignValues(userInfo?.major));
    setMinors(chipDesignValues(userInfo?.minor));
  }, [userInfo]);

  useMemo(() => {
    setFormErrors(formErrorsBasicInfo);
  }, [formErrorsBasicInfo]);

  useMemo(() => {
    const updatedFormData = {
      ...formData,
      major: selectedMajors?.map((major) => major?.name).join(', '),
      minor: selectedMinors?.map((minor) => minor?.name).join(', '),
    };
    getBasicInfo(updatedFormData);
  }, [formData, selectedMajors, selectedMinors]);

  const consignmentHandler = (event) => {
    setconsignment(event?.target?.checked);
  }

  const smsCheckedHandler = (event) => {
    setMentorSMS(event?.target?.checked);
  }

  const policyAndCondCheckedHandler = (e) => {
    setPolicyConditions(e?.target?.checked);
  }
  const policyAndCondition = (isPolicyAndCondChecked, policyAndCondCheckedHandler) => {
    return <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
      <Checkbox
        checked={isPolicyAndCondChecked}
        onChange={(e) => { policyAndCondCheckedHandler(e); } }
        inputProps={{ 'aria-label': 'controlled' }} />
      <Typography sx={{ mt: 2 }} variant="h4">{en.POLICY_TEXT}
        <Link target="_blank" href="https://www.yourcollegecontact.com/privacy-policy"> {en.PRIVACY_POLICY}</Link> and
        <Link target="_blank" href="https://www.yourcollegecontact.com/terms-conditions"> {en.TERM_AND_COND}</Link></Typography>
    </Box>;
  }
  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Typography variant="h3">{en.FIRST_WE_NEED_SOME_BASIC_INFORMATION}</Typography>
        <Box variant="form">
          <TextField
            name="name"
            value={formData.name}
            onChange={(e) => { handleChange(e) }}
            id="firstName"
            label="First Name"
            variant="filled"
            required
            error={!!formErrors?.name}
            helperText={formErrors?.name}
          />
          <TextField
            name="lastName"
            value={formData?.lastName}
            onChange={(e) => { handleChange(e) }}
            id="lastName"
            label="Last Name"
            variant="filled"
            required
            error={!!formErrors?.lastName}
            helperText={formErrors?.lastName}
          />
          <TextField
            name="email"
            value={BASIC_INFORMATION?.email}
            disabled={true}
            onChange={(e) => { handleChange(e) }}
            id="email"
            label="Email"
            variant="filled"
            required
          />
          <FormControl fullWidth >
            <FormLabel htmlFor="mobile">{en.PHONE_NUMBER}<span style={{ color: 'red', fontSize: '1em' }}>*</span></FormLabel>
            <PhoneInput
              country={'us'}
              value={formData.mobile}
              onChange={(value) => handleChange({ target: { name: 'mobile', value } })}
              id="mobile"
              name="mobile"
              inputStyle={{
                width: '96%',
                padding: '22px',
                marginLeft: '21px',
                fontSize: '15px',
                borderRadius: '4px',
                border: '0px solid #ced4da',
                backgroundColor: '#e7f4ff',
                transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
              }}
            />
            {formErrors?.mobile && <FormHelperText error>{formErrors?.mobile}</FormHelperText>}
          </FormControl>
          <TextField
            name="hometown"
            type="text"
            value={formData.hometown}
            onChange={(e) => { handleChange(e) }}
            id="Hometown"
            label="Hometown (ex: Los Angeles, CA)"
            variant="filled"
            required
            error={!!formErrors?.hometown}
            helperText={formErrors?.hometown}
          />

          {/* high school names */}
          <InputLabel id="selectHighSchoolabel" required>{en.HIGH_SCHOOL}</InputLabel>
          <Autocomplete
            name="highschool_id"
            options={highSchoolList?.result || []}
            getOptionLabel={(option) => option?.school_name || ''}
            value={highSchoolList?.result?.find(option => option?.id === formData?.highschool_id) || null}
            onChange={(event, newValue) => {
              const selectedHighSchoolId = newValue ? newValue.id : '';
              handleChange({ target: { name: 'highschool_id', value: selectedHighSchoolId } });
            }}
            inputValue={searchQuery}
            onInputChange={handleHighSchoolInputChange}
            ListboxProps={{
              onScroll: (event) => {
                const listboxNode = event.currentTarget;
                if (Math.ceil(listboxNode.scrollTop) + listboxNode.clientHeight === listboxNode.scrollHeight) {
                  loadMoreResults()
                }
              }
            }}
            renderInput={(params) => (
              <TextField {...params} variant="filled" required error={!!formErrors?.highschool_id} helperText={formErrors.highschool_id} />
            )}
          />

          {/* college & university are same  */}
          <InputLabel id="selectSchoolabel" required>{en.COLLEGE_NAME}</InputLabel>
          <Autocomplete
            name="school_id"
            options={universityList?.result || []}
            getOptionLabel={(option) => option.name || ''}
            value={universityList?.result?.find(option => option?.id === formData?.school_id) || null}
            onChange={(event, newValue) => {
              const selectedSchoolId = newValue ? newValue.id : '';
              handleChange({ target: { name: 'school_id', value: selectedSchoolId } });
            }}
            inputValue={searchQueryUniversity}
            onInputChange={handleSchoolInputChange}
            ListboxProps={{
              onScroll: (event) => {
                const listboxNode = event.currentTarget;
                if (Math.ceil(listboxNode.scrollTop) + listboxNode.clientHeight === listboxNode.scrollHeight) {
                loadMoreResultsUniversity()
                }
              }
            }}
            renderInput={(params) => (
              <TextField {...params} variant="filled" required error={!!formErrors?.school_id} helperText={formErrors.school_id} />
            )}
          />
          <TextField
            name="grad_year"
            type="number"
            value={formData.grad_year}
            onChange={(e) => { handleChange(e) }}
            label="College Graduation Year"
            variant="filled"
            required
            error={!!formErrors?.grad_year}
            helperText={formErrors?.grad_year}
          />
          <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="selectGradeLabel" required>{en?.GENDER}</InputLabel>
            <Select
              name="gender"
              labelId="grade"
              id="grade"
              value={formData?.gender}
              onChange={handleChange}
              required
              error={!!formErrors?.gender}
              helperText={formErrors?.gender}
            >
              <MenuItem value="select">{en.SELECT_THE_OPTION}</MenuItem>
              <MenuItem value="Male">Male</MenuItem>
              <MenuItem value="Female">Female</MenuItem>
              <MenuItem value="Non-Binary">Non-Binary</MenuItem>
              <MenuItem value="Decline to Answers">Decline to Answer</MenuItem>
            </Select>
            {!!formErrors?.gender && (<Typography variant="body2" color="error">{formErrors.gender}</Typography>)}
          </FormControl>
          <TextField
            name="major"
            type="text"
            value={formData.major}
            onChange={(e) => { handleChange(e) }}
            onKeyDown={(e) => {
              if (e.key === ',') {
                e.preventDefault();
              }
            }}
            label="Major"
            variant="filled"
            required
            disabled={selectedMajors?.length === 2}
            InputProps={{
              endAdornment:
                <InputAdornment>
                  <AddCircleOutlineOutlinedIcon data-testid="add-major-button" sx={{ cursor: "pointer" }} onClick={() => { handleAddChip("major") }} />
                </InputAdornment>
            }}
          />
          <ChipWrapper>
            {selectedMajors?.map((chip) => (
              <Chip
                key={chip?.id}
                label={chip?.name}
                onDelete={() => handleDeleteChip("major", chip.id)}
                deleteIcon={<CloseOutlinedIcon />}
              />
            ))}
          </ChipWrapper>
          { selectedMajors?.length === 0 && <div style={{ color: "#d32f2f", fontSize: "12px" }}> {en.MAJOR_REQUIRED} </div>}
          <TextField
            name="minor"
            type="text"
            value={formData.minor}
            onChange={(e) => { handleChange(e) }}
            onKeyDown={(e) => {
              if (e.key === ',') {
                e.preventDefault();
              }
            }}
            label="Minor"
            variant="filled"
            disabled={selectedMinors?.length === 2}
            InputProps={{
              endAdornment:
                <InputAdornment>
                  <AddCircleOutlineOutlinedIcon sx={{ cursor: "pointer" }} onClick={() => { handleAddChip("minor") }} />
                </InputAdornment>
            }}
          />
          <ChipWrapper>
            {selectedMinors?.map((chip) => (
              <Chip
                key={chip?.id}
                label={chip?.name}
                onDelete={() => handleDeleteChip("minor", chip.id)}
                deleteIcon={<CloseOutlinedIcon />}
              />
            ))}
          </ChipWrapper>
          <TextField
            name="google_meet_link"
            type="text"
            value={formData.google_meet_link}
            onChange={(e) => { handleChange(e) }}
            label="Google Meet Link"
            variant="filled"
            required
            error={!!formErrors?.google_meet_link}
            helperText={formErrors?.google_meet_link}
          />
          <TextField
            name="bio"
            type="text"
            value={formData.bio}
            multiline
            onChange={(e) => { handleChange(e) }}
            label="Bio"
            variant="filled"
            required
            error={!!formErrors?.bio}
            helperText={formErrors?.bio}
            InputProps={{
              sx: { fontSize:14,pl:3,py:"16px !important"},
            }}
          />
          <Box display="flex" alignItems="center" sx={{mb: 2}}>
            <Checkbox
              checked={isConsignmentChecked}
              onChange={(e) => { consignmentHandler(e) }}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            <Typography sx={{mt: 2}} variant="h4">{en.MENTOR_CONSIGNMENT}</Typography>
          </Box>
          {policyAndCondition(isPolicyAndCondChecked, policyAndCondCheckedHandler)}
          <Box display="flex" alignItems="center" sx={{mb: 2}}>
            <Checkbox
              checked={isSMSChecked}
              onChange={(e) => { smsCheckedHandler(e) }}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            <Typography sx={{mt: 2}} variant="h4">{en.SMS_CONSIGNMENT}</Typography>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default BasicInfo;